import notStartIcon from '../containers/AppManagement/Campaign/RecommendedGame/images/ic_login_oneline_gray_small.svg';
import activeIcon from '../containers/AppManagement/Campaign/RecommendedGame/images/ic_login_oneline_orange_small.svg';
import endedIcon from '../containers/AppManagement/Campaign/RecommendedGame/images/ic_login_oneline_green_small.svg';
import GradeIcons from 'enl-api/images/gradeIcons';
import React from 'react';
import Country from '../api/country/country';
import moment from 'moment';
import commonIcons from '../api/images/icons';

const numberToBitArr = (val) => val.toString(2);

// const errorMessage = '해당하는 타입에 매칭되는 정보가 없습니다.';

const notFound = (type) => {
    return `${type}에 해당하는 정보가 없습니다.`
}

export const needType = {
  1: '주 차량 등급 / 차종 / 레벨',
  2: '베이스 파워의 최대치',
  3: '레벨 총합',
  4: '능력치 합계',
  5: 'Speed 합계',
  6: 'Luck 합계',
  7: 'Energy 합계',
  8: 'Durability 합계',
  9: 'NFTSeal (인장)',
  10: '주 차량 등급 / 차종 / 레벨 / 능력치 합계',
};

export const getNeedTypeName = (type) => {
    if (needType.hasOwnProperty(type)) {
        return needType[type];
    }
    return notFound(type);
}

export const sealType = {
  0: 'None',
  1: 'Genesis',
  2: 'Evolved',
};

export const getSealType = (type) => {
    if (sealType.hasOwnProperty(type)) {
        return sealType[type];
    }
    return notFound(type);
}

export const nftType = {
  0: 'SUV',
  1: 'OFF-ROAD',
  2: 'SEDAN',
  3: 'SPORTS',
};

export const statisticsNftType = {
  1: 'SUV',
  2: 'OFF-ROAD',
  4: 'SEDAN',
  8: 'SPORTS',
};

export const nftGrade = {
  1: 'FREE',
  2: 'NORMAL',
  3: 'RARE',
  4: 'ELITE',
  5: 'EPIC',
  6: 'ULTIMATE',
  101: 'RENTAL',
};

export const boxType = {
  '': '전체',
  1: '브리딩',
  2: '제네시스',
};

export const getBoxType = (type) => {
    if (boxType.hasOwnProperty(type)) {
        return boxType[type];
    }
    return notFound(type);
}

export const boxGrade = {
  1: 'SILVER',
  2: 'GREEN',
  3: 'BLUE',
  4: 'ORANGE',
  5: 'RED',
};

export const getBoxName = (type) => {
    if (boxGrade.hasOwnProperty(type)) {
        return boxGrade[type];
    }
    return notFound(type);
}

export const plusInfo = {
  true: 'O',
  false: 'X',
};

export const itemLevel = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
};

export const itemType = {
    1: 'Breed',
    2: 'Evolve',
    3: 'Level Up',
    4: 'Restore',
    5: 'Evolve Booster',
    6: 'Gem Upgrade Booster',
    7: 'Power',
    8: 'Reset Stats',
    9: 'Event',
    10: 'Engine',
    11: 'Storage Upgrade',
    12: 'Vehicle Background',
    13: 'Engine Enhance Parts',
    14: 'Engine Enhance Protector',
    15: 'Engine Success Supporter',
    16: 'Level Up Booster',
    17: 'Decrease Breed Count',
    18: 'Bike Item',
    19: 'Pilot Core',
    20: 'Pilot Promotion Parts',
    100: 'Gem',
    201: 'All Package Box',
    202: 'Rate Box',
    203: 'Select Box',
    204: 'Multiple Box'
};

export const getItemName = (type) => {
    if (itemType.hasOwnProperty(type)) {
        return itemType[type];
    }
    return notFound(type);
}

export const gemColor = {
  1: 'Red',
  2: 'Green',
  3: 'Yellow',
  4: 'Blue',
};

export const getGemColor = (type) => {
    if (gemColor.hasOwnProperty(type)) {
        return gemColor[type];
    }
    return notFound(type);
}

export const gemEffect = {
  1: 'Speed (%)',
  2: 'Luck (%)',
  3: 'Energy (%)',
  4: 'Durability (%)',
  5: 'Speed (+)',
  6: 'Luck (+)',
  7: 'Energy (+)',
  8: 'Durability (+)',
};


export const getGemEffect = (type) => {
    if (gemEffect.hasOwnProperty(type)) {
      return gemEffect[type];
    }
    return notFound(type);
}





export const getCarType = (type) => {
    if (type === undefined) {
      return '-';
    }

    if (type === 0) {
      return 'SUV, OFF-ROAD, SEDAN, SPORTS';
    }

    const carTypes = numberToBitArr(type).split('').reverse();
    const resultType = [];

    if (carTypes[0] === '1') {
      resultType.push('SUV');
    }
    if (carTypes[1] === '1') {
      resultType.push('OFF-ROAD');
    }
    if (carTypes[2] === '1') {
      resultType.push('SEDAN');
    }
    if (carTypes[3] === '1') {
      resultType.push('SPORTS');
    }

    if (resultType.length === 0) {
      return '-';
    }

    return resultType.join(', ');
}


export const getBikeImage = (type) => {

    const uri = window.location.href;
    // const IS_PROD = uri.includes('perplay-bo-web-prod.azurewebsites.net');
    const IS_TEST = uri.includes('localhost') || uri.includes('perplay-bo-web-test.azurewebsites.net');

    switch (type){
        case 1:
            return IS_TEST ?
                    <img className="tableMedia" src={"https://perplayblobdev.blob.core.windows.net/nft-storage/nft/BikeSuv.png"} alt="image" />
                    : <img className="tableMedia" src={"https://perplay-cdn-prod.azureedge.net/nft-storage/nft/BikeSuv.png"} alt="image" />
        case 2:
            return IS_TEST ?
                <img className="tableMedia" src={" https://perplayblobdev.blob.core.windows.net/nft-storage/nft/BikeOffroad.png"} alt="image" />
                : <img className="tableMedia" src={"https://perplay-cdn-prod.azureedge.net/nft-storage/nft/BikeOffroad.png"} alt="image" />
        case 4:
            return IS_TEST ?
                <img className="tableMedia" src={"https://perplayblobdev.blob.core.windows.net/nft-storage/nft/BikeSedan.png"} alt="image" />
                : <img className="tableMedia" src={"https://perplay-cdn-prod.azureedge.net/nft-storage/nft/BikeSedan.png"} alt="image" />
        case 8:
            return IS_TEST ?
                <img className="tableMedia" src={"https://perplayblobdev.blob.core.windows.net/nft-storage/nft/BikeSports.png"} alt="image" />
                : <img className="tableMedia" src={"https://perplay-cdn-prod.azureedge.net/nft-storage/nft/BikeSports.png"} alt="image" />
    }
}

/**
 *
 * @type {{}}
 *
 *
 *         Normal = 1,
 *         Rare = 2,
 *         Elite = 3,
 *         Epic = 4,
 *         Ultimate = 5,
 */
export const pilotRarity = {
    1: "Normal",
    2: "Rare",
    3: "Elite",
    4: "Epic",
    5: "Ultimate"
}

export const getPilotRarity = (type) => {
    if (pilotRarity.hasOwnProperty(type)) {
        return pilotRarity[type];
    }
    return notFound(type);
}

export const getPilotGradeIcon = (grade) => {
    switch (grade) {
        case 1:
            return (
                <img
                    className="tableMedia"
                    alt="gradeIcons"
                    src={GradeIcons?.normalIcon}
                />
            );
        case 2:
            return (
                <img
                    className="tableMedia"
                    alt="gradeIcons"
                    src={GradeIcons?.rareIcon}
                />
            );
        case 3:
            return (
                <img
                    className="tableMedia"
                    alt="gradeIcons"
                    src={GradeIcons?.eliteIcon}
                />
            );
        case 4:
            return (
                <img
                    className="tableMedia"
                    alt="gradeIcons"
                    src={GradeIcons?.epicIcon}
                />
            );
        case 5:
            return (
                <img
                    className="tableMedia"
                    alt="gradeIcons"
                    src={GradeIcons?.ultimateIcon}
                />
            );
        default:
            return '-';
    }
}

export const pilotStatType = {
    1: "Speed",
    2: "Luck",
    3: "Energy",
    4: "Durability",
}

export const getPilotStatType = (type) => {
    if (pilotStatType.hasOwnProperty(type)) {
        return pilotStatType[type];
    }
    return notFound(type);
}

/**
 *
 * @type {{}}
 *
 *         SpecialBoxLevelUp = 1, // 스페셜 박스 일정 확률로 레벨 + 1
 *         ExtraPowerLimitPlus = 2, // 엑스트라 파워 리미트 증가
 *         PowerStoragePlus = 3, // 파워 저장소 증가
 *         DailyMiningLimitPlus = 4, // 일일 채굴량 한도 증가
 *         BreedingCooldown = 5, // 브리딩 쿨타임 감소
 *         TransferFeeDown = 6, // 전송 수수료 감소
 *         PolishedBoxRateUp = 7, // 폴리쉬드 박스 확률 증가
 *         PlusFlagRateUp = 8, // 플러스 플래그 확률 증가
 *         LevelUpDurationDown = 9, // 레벨업 대기 시간 감소
 *         SpecialBoxDurationDown = 10, // 스페셜 박스 오픈시간 감소
 *         AfterAcquisitionLimitTimeBreed = 11, // 차량 NFT 획득 후 브리딩 제한 시간 감소
 *         AfterAcquisitionLimitTimeEvolve = 12, // 차량 NFT 획득 후 이볼브 제한 시간 감소
 *         AfterAcquisitionLimitTimeDisassemble = 13, // 차량 NFT 획득 후 분해 제한 시간 감소
 *         AfterAcquisitionLimitTimeRegSell = 14, // 차량 NFT 획득 후 판매 제한 시간 감소
 *         AfterAcquisitionLimitTimeTransfer = 15, // 차량 NFT 획득 후 전송 제한 시간 감소
 *         XperMiningBonus = 16, // Xper 채굴 보너스 증가
 *         BreedingCountIgnore = 17, // 브리딩 시 일정 확률로 카운트 증가 하지 않음
 *         RainbowGemCooldown = 18, // 무지개 보석 장착 후 해제 쿨타임 감소
 *         DailyMissionReward = 19, // 베이직 모드 일일 미션 보상 증가
 */
export const pilotSkillType = {
    1: "스페셜 박스 일정 확률로 레벨 + 1",
    2: "엑스트라 파워 리미트 증가",
    3: "파워 저장소 증가",
    4: "일일 채굴량 한도 증가",
    5: "브리딩 쿨타임 감소",
    6: "전송 수수료 감소",
    7: "폴리쉬드 박스 확률 증가",
    8: "플러스 플래그 확률 증가",
    9: "레벨업 대기 시간 감소",
    10: "스페셜 박스 오픈시간 감소",
    11: "차량 NFT 획득 후 브리딩 제한 시간 감소",
    12: "차량 NFT 획득 후 이볼브 제한 시간 감소",
    13: "차량 NFT 획득 후 분해 제한 시간 감소",
    14: "차량 NFT 획득 후 판매 제한 시간 감소",
    15: "차량 NFT 획득 후 전송 제한 시간 감소",
    16: "Xper 채굴 보너스 증가",
    17: "브리딩 시 일정 확률로 카운트 증가 하지 않음",
    18: "무지개 보석 장착 후 해제 쿨타임 감소",
    19: "베이직 모드 일일 미션 보상 증가"
}

export const getPilotSkillType = (type) => {
    if (pilotSkillType.hasOwnProperty(type)) {
        return pilotSkillType[type];
    }
    return notFound(type);
}


// export const getStatusIcon = (start, end, isLock, depositTransactionStatus) => {
//     if (
//       start !== undefined &&
//       start !== null &&
//       end !== undefined &&
//       end !== null
//     ) {
//       const curDate = moment.utc().format('YYYY-MM-DD A HH:mm');
//       const startTime = moment(start).format('YYYY-MM-DD A HH:mm');
//       const endTime = moment(end).format('YYYY-MM-DD A HH:mm');
//       let status = <>-</>;
//       if (curDate < startTime) {
//         status = (
//           <>
//             <img src={notStartIcon} /> 시작 전
//           </>
//         );
//       } else if (curDate >= startTime && curDate < endTime) {
//         status = (
//           <>
//             <img src={activeIcon} /> 활성
//           </>
//         );
//
//         if (isLock) {
//           status = (
//             <>
//               <img src={notStartIcon} /> 일시정지
//             </>
//           );
//         }
//
//         // if(Number(depositTransactionStatus)) {
//         if (depositTransactionStatus && depositTransactionStatus !== 1) {
//           status = (
//             <>
//               <img src={notStartIcon} /> 취소
//             </>
//           );
//         }
//       } else if (curDate >= endTime) {
//         status = (
//           <>
//             <img src={endedIcon} /> 완료
//           </>
//         );
//       }
//       return status;
//     }
//     return '-';
// }

// export const getStatusIcons = (start, end, isLock, depositTransactionStatus) => {
//     if (
//       start !== undefined &&
//       start !== null &&
//       end !== undefined &&
//       end !== null
//     ) {
//       const curDate = moment.utc();
//       // curDate를 UTC 시간으로 변환
//       const curDateUTC = curDate + new Date().getTimezoneOffset() * 60000;
//       let status = <>-</>;
//
//       if (start > curDateUTC) {
//         status = (
//           <>
//             <img src={notStartIcon} /> 시작 전
//           </>
//         );
//       } else if (start <= curDateUTC && end > curDateUTC) {
//         status = (
//           <>
//             <img src={activeIcon} /> 활성
//           </>
//         );
//         if (isLock) {
//           status = (
//             <>
//               <img src={notStartIcon} /> 일시정지
//             </>
//           );
//         }
//
//         if (depositTransactionStatus && depositTransactionStatus !== 1) {
//           status = (
//             <>
//               <img src={notStartIcon} /> 취소
//             </>
//           );
//         }
//       } else if (start < curDateUTC && end <= curDateUTC) {
//         status = (
//           <>
//             <img src={endedIcon} /> 완료
//           </>
//         );
//       }
//       return status;
//     }
//     if (end === null) {
//       const curDate = new Date().getTime();
//       // curDate를 UTC 시간으로 변환
//       const curDateUTC = curDate + new Date().getTimezoneOffset() * 60000;
//       let status = <>-</>;
//
//       if (start <= curDateUTC) {
//         status = (
//           <>
//             <img src={activeIcon} /> 활성
//           </>
//         );
//       } else if (start > curDateUTC) {
//         status = (
//           <>
//             <img src={notStartIcon} /> 시작 전
//           </>
//         );
//       }
//       return status;
//     }
//     return '-';
// }

export const getNftEventStateIcon = (start, end, isLock, depositTransactionStatus) => {
    if (
      start !== undefined &&
      start !== null &&
      end !== undefined &&
      end !== null
    ) {
      if (isLock <= 0) {
        let status = <>-</>;
        status = (
          <>
            <img src={endedIcon} /> 수량 소진
          </>
        );
        return status;
      }
      if (isLock === false) {
        let status = <>-</>;
        status = (
          <>
            <img src={endedIcon} /> 예산 소진으로 완료
          </>
        );
        return status;
      }

      if (depositTransactionStatus && depositTransactionStatus !== 1) {
        let status = <>-</>;
        status = (
          <>
            <img src={notStartIcon} /> 취소
          </>
        );
        return status;
      }
      const curDate = moment.utc();
      // curDate를 UTC 시간으로 변환
      const curDateUTC = curDate + new Date().getTimezoneOffset() * 60000;
      let status = <>-</>;

      if (start > curDateUTC) {
        status = (
          <>
            <img src={notStartIcon} /> 시작 전
          </>
        );
      } else if (start <= curDateUTC && end > curDateUTC) {
        status = (
          <>
            <img src={activeIcon} /> 활성
          </>
        );
        if (isLock === true) {
          status = (
            <>
              <img src={notStartIcon} /> 일시정지
            </>
          );
        }

        // if (depositTransactionStatus !== 1) {
        //   status = (
        //     <>
        //       <img src={notStartIcon} /> 취소
        //     </>
        //   );
        // }
      } else if (start < curDateUTC && end <= curDateUTC) {
        status = (
          <>
            <img src={endedIcon} /> 완료
          </>
        );
      }
      return status;
    }
    if (end === null) {
      const curDate = new Date().getTime();
      // curDate를 UTC 시간으로 변환
      const curDateUTC = curDate + new Date().getTimezoneOffset() * 60000;
      let status = <>-</>;

      if (start <= curDateUTC) {
        status = (
          <>
            <img src={activeIcon} /> 활성
          </>
        );
      } else if (start > curDateUTC) {
        status = (
          <>
            <img src={notStartIcon} /> 시작 전
          </>
        );
      }
      return status;
    }
    return '-';
}

  // 등급에 따른 이미지 변환
  //차량
export const getGradeIcon = (grade) => {
    switch (grade) {
      case 1:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.freeIcon}
          />
        );
      case 2:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.normalIcon}
          />
        );
      case 3:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.rareIcon}
          />
        );
      case 4:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.eliteIcon}
          />
        );
      case 5:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.epicIcon}
          />
        );
      case 6:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.ultimateIcon}
          />
        );
      case 101:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.rentalIcon}
          />
        );
      default:
        return '-';
    }
}

  // 등급에 따른 텍스트 변환
  //차량
export const getNftCarGradeText = (grade) => {
    switch (grade) {
      case 1:
        return 'FREE';
      case 2:
        return 'NORMAL';
      case 3:
        return 'RARE';
      case 4:
        return 'ELITE';
      case 5:
        return 'EPIC';
      case 6:
        return 'ULTIMATE';
      case 101:
        return 'RENTAL';
      default:
        return '-';
    }
}

  // 박스
export const getBoxGradeIcon = (grade) => {
    switch (grade) {
      case 1:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.silver}
          />
        );
      case 2:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.green}
          />
        );
      case 3:
        return (
          <img className="tableMedia" alt="gradeIcons" src={GradeIcons?.blue} />
        );
      case 4:
        return (
          <img
            className="tableMedia"
            alt="gradeIcons"
            src={GradeIcons?.orange}
          />
        );
      case 5:
        return (
          <img className="tableMedia" alt="gradeIcons" src={GradeIcons?.red} />
        );
      default:
        return '-';
    }
}

export const checkRegion = (region, type) => {
    let regionText = '';
    if (region !== null && region !== undefined && region !== '') {
      let cnt = 0;
      if (region === '0') {
        Country.forEach((value, index) => {
          if (index === 0) {
            regionText += value.name;
          } else if (type === 'detail') {
            regionText += ', ' + value.name;
          }
          cnt += 1;
        });
      } else {
        const list = region.split(',');
        Country.forEach((value) => {
          list.forEach((r) => {
            if (value.countryCode === r) {
              if (cnt === 0) {
                regionText += value.name;
              } else if (type === 'detail') {
                regionText += ', ' + value.name;
              }
              cnt += 1;
            }
          });
        });
      }

      if (type === 'list' && cnt > 1) {
        regionText += ' 외 ' + (cnt - 1) + '국';
      }
    }
    return regionText;
}

export const checkToken = (type) => {
    switch (type) {
      case 1:
        return 'PER';
      case 2:
        return 'XPER';
      case 3:
        return 'PER, XPER';
      default:
        return 'XPER';
    }
}


